import React from 'react';
import { useParams } from 'react-router-dom';
import { notification, Tabs, Progress } from 'antd';
import { selectDocumentsRecord } from "../redux/api/documents/documentsSelectors";
import DocumentPropertyComparison from "../components/tabs/DocumentPropertyComparison";
import ComparisonHeatmap from "../components/plots/ComparisonHeatmap";
import { useAllDocumentsReady } from "../hooks/useAllDocumentsReady";
import { useAppSelector } from "../redux/hooks";

interface RouteParams extends Record<string, string | undefined> {
    documentId?: string;
}

const DocumentsComparisonPage: React.FC = () => {
    const { documentId } = useParams<RouteParams>();

    // Проверяем, загружены ли все документы (detailLoaded)
    const { isLoading, progress, error } = useAllDocumentsReady();
    const documentsRecord = useAppSelector(selectDocumentsRecord);

    // Если есть ошибка глобальной загрузки
    if (error) {
        notification.error({
            message: 'Ошибка загрузки документов',
            description: error,
        });
        return <div className="p-4">{error}</div>;
    }

    // Если ещё идёт загрузка всех документов
    if (isLoading) {
        return <Progress percent={progress} status="active" />;
    }

    // Если нужен конкретный документ (по параметру), можем его проверить
    let selectedDoc = documentId ? documentsRecord[documentId] : undefined;

    if (!selectedDoc) {
        return (
            <div className="p-4">
                <h2 className="text-xl">Документ не найден</h2>
            </div>
        );
    }

    const items = [
        {
            key: '1',
            label: 'Сравнение свойств документов',
            children: (
                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                    }}
                >
                    <DocumentPropertyComparison
                        documents={documentsRecord}
                        documentData={selectedDoc}
                    />
                </div>
            ),
        },
        {
            key: '2',
            label: 'Тепловая карта свойств',
            children: (
                <div
                    style={{
                        flex: 1,
                        display: 'flex',
                        flexDirection: 'column',
                        minHeight: 0,
                    }}
                >
                    <ComparisonHeatmap documents={documentsRecord} />
                </div>

            ),
        },
    ];

    return (
        <div
            style={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                minHeight: 0,
            }}
        >
            <Tabs
                defaultActiveKey="1"
                items={items}
                // Важный момент: делаем Tabs флекс-элементом
                style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}
                tabBarStyle={{ marginBottom: 0 }}
            />
        </div>
    );
};

export default DocumentsComparisonPage;
